"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AssetProxyOwner = require("../artifacts/AssetProxyOwner.json");

exports.AssetProxyOwner = AssetProxyOwner;

var Coordinator = require("../artifacts/Coordinator.json");

exports.Coordinator = Coordinator;

var CoordinatorRegistry = require("../artifacts/CoordinatorRegistry.json");

exports.CoordinatorRegistry = CoordinatorRegistry;

var DummyERC20Token = require("../artifacts/DummyERC20Token.json");

exports.DummyERC20Token = DummyERC20Token;

var DummyERC721Token = require("../artifacts/DummyERC721Token.json");

exports.DummyERC721Token = DummyERC721Token;

var DutchAuction = require("../artifacts/DutchAuction.json");

exports.DutchAuction = DutchAuction;

var ERC20Proxy = require("../artifacts/ERC20Proxy.json");

exports.ERC20Proxy = ERC20Proxy;

var ERC20Token = require("../artifacts/ERC20Token.json");

exports.ERC20Token = ERC20Token;

var ERC721Proxy = require("../artifacts/ERC721Proxy.json");

exports.ERC721Proxy = ERC721Proxy;

var ERC721Token = require("../artifacts/ERC721Token.json");

exports.ERC721Token = ERC721Token;

var Exchange = require("../artifacts/Exchange.json");

exports.Exchange = Exchange;

var Forwarder = require("../artifacts/Forwarder.json");

exports.Forwarder = Forwarder;

var IValidator = require("../artifacts/IValidator.json");

exports.IValidator = IValidator;

var IWallet = require("../artifacts/IWallet.json");

exports.IWallet = IWallet;

var MultiAssetProxy = require("../artifacts/MultiAssetProxy.json");

exports.MultiAssetProxy = MultiAssetProxy;

var OrderValidator = require("../artifacts/OrderValidator.json");

exports.OrderValidator = OrderValidator;

var WETH9 = require("../artifacts/WETH9.json");

exports.WETH9 = WETH9;

var ZRXToken = require("../artifacts/ZRXToken.json");

exports.ZRXToken = ZRXToken;